export function stringOrEmptyString(stringToCheck: string | null | undefined): string {
	return stringToCheck || "";
}
export function isEmpty(obj?: Record<string, unknown> | null): boolean {
	if (!obj) {
		return true;
	}

	return obj.constructor === Object && Object.keys(obj).length === 0;
}
// Math.random is not cryptographically safe! Do not use for any task that has security implications
export function uniqueId(prefix?: string): string {
	return `${prefix ?? ""}${Math.random().toString(16).slice(2)}`;
}

export async function fetchWithTimeout(input: RequestInfo, init: RequestInit & { timeoutInSeconds?: number } = {}) {
	const { timeoutInSeconds, ...initFetch } = init;
	if (!timeoutInSeconds) {
		return await fetch(input, initFetch);
	}
	const controller = new AbortController();
	const timeoutId = setTimeout(() => controller.abort(), timeoutInSeconds * 1000);
	try {
		return await fetch(input, {
			...initFetch,
			signal: controller.signal,
		});
	} catch (err) {
		if (err instanceof DOMException && err.name === "AbortError") {
			throw new Error("Network timed out");
		}
		throw err;
	} finally {
		clearTimeout(timeoutId);
	}
}

export type SyncResponse = {
	status: number;
	headers: Headers;
	text: string;
	ok: boolean;
};

export async function fetchWithTimeoutSyncResponse(
	input: RequestInfo,
	init: RequestInit & { timeoutInSeconds?: number } = {},
): Promise<SyncResponse> {
	return fetchWithTimeout(input, init).then(async function (response: Response): Promise<SyncResponse> {
		return {
			status: response.status,
			headers: response.headers,
			text: await response.text(),
			ok: response.ok,
		};
	});
}
